import {useState, useEffect} from 'react';
import {useParams } from 'react-router-dom';
import PortraitsSection from '../../components/PortraitsSection/PortaitsSection';
import InstaGrid from '../../components/InstaGrid/InstaGrid';
import MediaService from '../../services/mediaService';
import "../../index.css";
import "./PhotoGalleryPage.css";
import familyImage from './images/1080p AJ & Family 2.jpg';
import modelImage from './images/OFW-female-9.jpg';
import weddingImage from './images/wedding-still.webp';
import StandardText from '../../components/StandardText/StandardText';
import ButtonCover from '../../components/ButtonCover/ButtonCover';


function PhotoGalleryPage({classification}) {
  const [middleCTASrc, setMiddleCTASrc] = useState('');
  const [portraitHeroSet, setPortraitHeroSet] = useState([]);
  const [family, setFamily] = useState([]);
  const [professionalHeadshots, setProfessionalHeadshots] = useState([]);
  const [glamour, setGlamour] = useState([]);
  const [models, setModels] = useState([]);
  const [portraitVideoSrc, setPortraitVideoSrc] = useState('');

  let titlePhrase
  let firstSectionImageList = [{
    src: familyImage,
    alt: "Family portrait outdoors"
  }, 
  {
    src: modelImage,
    alt: "Model portrait"
  },
  {
    src: weddingImage,
    alt: "Wedding photo"
  }
];
  
console.log("professional Headshots:", professionalHeadshots);
useEffect(() => {
  let isActive = true;

  const loadMedia = async () => {
    try {
      const [ portraitHeroGallery, familyGallery, professionalHeadshotsGallery, glamourGallery, modelGallery, videoSrc, ctaSrc] = await Promise.all([
        MediaService.getGallery('assets', 'photo', 'portrait-hero-set/'),
        MediaService.getGallery('portraits', 'photo', 'family/'),
        MediaService.getGallery('portraits', 'photo', 'professional-headshots/'),
        MediaService.getGallery('portraits', 'photo', 'glamour/'),
        MediaService.getGallery('portraits', 'photo', 'model/'),
        MediaService.getMediaUrl(
          'assets',
          'video',
          'video-portraits-cover',
          'portrait-video-cover.mp4'
        ),
        MediaService.getMediaUrl(
          'assets',
          'photo',
          'portrait-page',
          'monument-kick.webp'
        )
      ]);

      if (isActive) {
        setPortraitHeroSet(
          portraitHeroGallery
            .filter((media) => media.id !== '')
            .sort((a, b) => Number(a.id[0]) - Number(b.id[0]))
            .map((media) => ({
              ...media,
              type: media.type || 'image',
              alt: media.alt || media.id
            }))
        );
        setFamily(
          familyGallery
            .filter((media) => media.id !== '')
            .sort((a, b) => Number(a.id[0]) - Number(b.id[0]))
            .map((media) => ({
              ...media,
              type: media.type || 'image',
              alt: media.alt || media.id
            }))
        );
        setProfessionalHeadshots(
          professionalHeadshotsGallery
            .filter((media) => media.id !== '')
            .sort((a, b) => Number(a.id[0]) - Number(b.id[0]))
            .map((media) => ({
              ...media,
              type: media.type || 'image',
              alt: media.alt || media.id
            }))
        );
        setGlamour(
          glamourGallery
            .filter((media) => media.id !== '')
            .sort((a, b) => Number(a.id[0]) - Number(b.id[0]))
            .map((media) => ({
              ...media,
              type: media.type || 'image',
              alt: media.alt || media.id
            }))
        );
        setModels(
          modelGallery
            .filter((media) => media.id !== '')
            .sort((a, b) => Number(a.id[0]) - Number(b.id[0]))
            .map((media) => ({
              ...media,
              type: media.type || 'image',
              alt: media.alt || media.id
            }))
        );
        setPortraitVideoSrc(videoSrc);
        setMiddleCTASrc(ctaSrc);
      }
    } catch (error) {
      console.error('Failed to load portrait gallery media:', error);
    }
  };

  loadMedia();

  return () => {
    isActive = false;
  };
}, []);

  switch(classification){
      case "portrait":
      titlePhrase = "Photo Portraits"
      break;
    case "commercial":
      titlePhrase = "Commercial Photos"
      break;
    case "cinematic":
      titlePhrase = "Cinematic Photos"
      break;
    default:
      titlePhrase = "Non-Descript Photos"
    
  }

  return (

    <div className="proto-page-container">

        <PortraitsSection class_Name="portraits-section-styles border-white-bottom" imageList={portraitHeroSet}
          title = 'Portraits'
          description = "Whether you're looking to capture a special moment with your family, want to commemorate the special bond you have with your sweetheart, or are looking to show off your killer smile for personal branding, we offer a varied selection of services to help your vision come to life."
          subtext = 'Personal · Family · Professional Headshots · Engagements · Model · Glamour · Editorial'
          buttonText = 'PLAN YOUR SESSION'
        />

        <div className="section-page-title clr-dark-blue" >{"Family"}</div>
        <InstaGrid id="family" contentList={family} class_Name="insta-grid-styles"/>

        <div className="section-page-title clr-dark-blue" >{"Professional Headshots"}</div>
        <InstaGrid id="professional-headshots" contentList={professionalHeadshots} class_Name="headshot-grid-styles border-white-bottom"/>

        <div className="flex-column-centered middle-cta border-white-bottom">
<div className="cta-image-container">
  <img src={middleCTASrc} alt="model in front of a monument" className="cta-image" />
</div>
          <StandardText class_Name="clr-dark-red font-size-3 margin-bottom-5 centered-text ">Ready to start booking your session? Click below to see pricing packages for portraiture services.</StandardText>
          <button className={'bg-dark-blue cta-button'}>
            See Packages
          </button>
        </div>

        <div className="section-page-title clr-dark-blue" >{"Glamour"}</div>
        <InstaGrid id="glamour" contentList={glamour} class_Name="insta-grid-styles"/>

        <div className="section-page-title clr-dark-blue" >{"Models"}</div>
        <InstaGrid id="models" contentList={models} class_Name="insta-grid-styles"/>

        <PortraitsSection class_Name="portraits-section-styles video-portrait-section-container"
          videoSrc={portraitVideoSrc} mediaOrientation="vertical" reverseOnDesktop={true}
          subtext = "Want to stand out from the crowd? Take at look at our signature “Video Portrait”. This format is for those wanting to brand themselves with a distinct touch. If a picture’s worth a thousand words, how much more valuable is one in motion?"
          buttonText = 'Video Portraits'
        />


    </div>
   
  );
}

export default PhotoGalleryPage
;
